<template>
    <section>
        <!--顶部查询条件-->
        <Form :model="tqtPublicServicePlatform" inline>
            <FormItem>
                <Input v-model="tqtPublicServicePlatform.platformName" placeholder="平台名称" clearable></Input>
            </FormItem>
            <FormItem>
                <Select v-model="tqtPublicServicePlatform.platformLevelType" placeholder="平台级别" class="query-model"
                        clearable>
                    <Option value="1">1、市级</Option>
                    <Option value="2">2、区级</Option>
                </Select>
            </FormItem>
            <!--查询按钮-->
            <FormItem>
                <Button icon="ios-search" shape="circle" @click="search">查询</Button>
            </FormItem>
            <FormItem>
                <Button icon="md-add" type="primary" shape="circle" @click="create">新增</Button>
            </FormItem>

            <!-- 导出按钮 -->
            <FormItem>
                <Button type="primary" icon="md-download" shape="circle" @click="exportData">导出</Button>
            </FormItem>

        </Form>
        <Table border :columns="columns" :data="tableData" :loading="loading"></Table>
        <div class="page-area">
            <Page :total="pageTotal" :current="pageOffset" :page-size="pageLength" @on-change="handlePageChange"
                  show-total show-elevator/>
        </div>
        <relationCom ref="relationCom"></relationCom>
    </section>
</template>
<script>
    import util from '@/libs/util.js'
    import relationCom from './relationCom'

    export default {
        name: 'tqtPublicServicePlatformList',
        components: {
            relationCom
        },

        data () {
            return {
                //分页参数
                pageLength: 10, // 每页条数
                pageTotal: 0,//总数
                pageOffset: 1, //页码
                //查询参数
                tqtPublicServicePlatform: {
                    platformName: '',
                    platformLevelType: '',
                },
                columns: [
                    {
                        key: 'order',
                        title: '诉求编号',
                        align: 'center',
                        width:95
                    },
                    {
                        key: 'platformName',
                        title: '公众平台名称',
                        align: 'center'
                    },
                    {
                        key: 'platformLevelName',
                        title: '公众平台级别',
                        align: 'center'
                    },
                    {
                        key: 'platformIcon',
                        title: '公众平台图标',
                        align: 'center',
                        width: 180,
                        render: (h, params) => {
                            return h('div', [
                                h('Img', {
                                    style:{marginTop:'5px'},
                                    attrs: {
                                        src: params.row.platformIcon.url || '',
                                        height: '80',
                                    },
                                }),
                            ])
                        },
                    },
                    {
                        key: 'platformUrl',
                        title: '公众平台链接',
                        align: 'center'
                    },
                    {
                        key: 'createTime',
                        title: '创建时间',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h(
                                        'span',
                                        {
                                            domProps: {
                                                innerHTML: this.formatTime(params.row.createTime)
                                            },
                                        },
                                ),
                            ])
                        }
                    },

                    {
                        title: '操作',
                        align: 'center',
                        width: 190,
                        key: 'id',
                        render: (h, params) => {
                            return h('div', [
                                h(
                                        'Button',
                                        {
                                            props: {
                                                type: 'warning',
                                                size: 'small'
                                            },
                                            on: {
                                                click: () => {
                                                    this.edit(params.row)
                                                }
                                            }
                                        },
                                        '编辑'
                                ),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        marginLeft: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.id)
                                        }
                                    }
                                }, '删除')
                            ])
                        }
                    }
                ],
                tableData: [],
                loading: false,

            }
        },
        mounted () {
            this.listTable()
        },
        methods: {
            formatTime (UTCDateString) {
                if (!UTCDateString) {
                    return '-'
                }

                function formatFunc (str) {    //格式化显示
                    return str > 9 ? str : '0' + str
                }

                var date2 = new Date(UTCDateString)     //这步是关键
                var year = date2.getFullYear()
                var mon = formatFunc(date2.getMonth() + 1)
                var day = formatFunc(date2.getDate())
                var hour = date2.getHours()
                var min = formatFunc(date2.getMinutes())
                var second = date2.getSeconds()
                var dateStr = year + '-' + mon + '-' + day
                return dateStr
            },
            //渲染表格数据
            listTable () {
                let _this = this
                _this.loading = true
                _this.$util.http
                        .get('/api/tqtPublicServicePlatformsList', {
                            params: {
                                page: _this.pageOffset,
                                size: _this.pageLength,
                                'platformName': _this.tqtPublicServicePlatform.platformName,
                                'platformLevelType': _this.tqtPublicServicePlatform.platformLevelType,
                                //  'title': _this.tqtJournalism.title,
                            }
                        })
                        .then(function (response) {
                            _this.tableData = []
                            let data = response.data
                            _this.pageTotal = data.recordsTotal
                            let list = data.data
                            _this.tableData = list.map((item, key) => {
                                item.order = key + 1
                                return item
                            })
                            imagePath:  list[i].imagePath
                            _this.loading = false
                        })
                        .catch(function (error) {
                            console.log(error)
                            _this.loading = false
                        })
            },
            //新建
            create () {
                this.$refs['relationCom'].title = '新增'
                this.$refs['relationCom'].visible = true
                // this.$router.push({
                //     name: 'tqt_public_service_platform_item',
                // })
            },
            //导出
            exportData () {
                let params = {
                  platformName: this.tqtPublicServicePlatform.platformName,
                  platformLevelType: this.tqtPublicServicePlatform.platformLevelType
                }
                util.http.post(`/api/tqtPublicServicePlatforms/export`, { params }, { responseType: 'blob' }).then(res => {
                  if (res.headers['content-disposition']) {
                    let name = res.headers['content-disposition'].split('=')[1]
                    name = decodeURI(name)
                    let fileName = {
                      name: name,
                      type: res.headers['content-type']
                    }
                    this.funDown(res.data, fileName)
                  }
                })
            },
            funDown (data, fileName) {
              let blob = new Blob([data], {type: fileName.type})
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName.name)
              } else {
                let link = document.createElement('a')
                link.target = '_blank'
                link.href = window.URL.createObjectURL(blob)
                link.download = fileName.name
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
              }
            },
            //编辑
            edit (row) {
                this.$refs['relationCom'].title = '编辑'
                this.$refs['relationCom'].model = { ...row }
                this.$refs['relationCom'].model.platformIcon = row.platformIcon.uri || ''
                this.$refs['relationCom'].picList = [{...row.platformIcon}]
                this.$refs['relationCom'].visible = true
            },
            //删除
            delete (id) {
                let _this = this
                this.$Modal.confirm({
                    title: '确定删除？',
                    onOk () {
                        _this.$util.http.delete('/api/tqtPublicServicePlatforms/' + id).then(response => {
                            if (response.status === 200) {
                                _this.$Notice.success({
                                    title: '删除成功'
                                })
                                _this.listTable()
                            } else {
                                _this.$Notice.error({
                                    title: '删除失败'
                                })
                            }
                        })
                    }
                })
            },
            //查询
            search () {
                this.pageOffset = 1
                this.listTable()
            },
            handlePageChange (current) {
                this.pageOffset = current
                this.listTable()
            }
        }
    }
</script>
<style scoped>
    .query-model {
        width: 170px;
    }

    .page-area {
        display: flex;
        justify-content: flex-end;
        padding-top: 35px;
        padding-right: 50px;
    }
</style>
